import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, IconButton, InputBase } from '@material-ui/core';
import AddressIcon from './AddressIcon';
import T from './tokens';

// 접수 폼 입력창(.textBox)과 같은 틀 — 높이 50, 모서리 8, 테두리 #e4e4e9. 포커스 시 주황 테두리와 그림자
const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: T.rowHeight,
    padding: '0 8px 0 14px',
    borderRadius: T.radius,
    border: `1px solid ${T.line}`,
    backgroundColor: T.surface,
    transition: 'border-color .15s, box-shadow .15s',
    '&:focus-within': {
      borderColor: T.primary,
      boxShadow: T.shadow,
    },
  },
  icon: {
    flex: 'none',
    color: T.muted,
    marginRight: 8,
    display: 'flex',
  },
  input: {
    flex: 1,
    fontSize: 16,
    letterSpacing: -0.8,
    color: T.ink,
    '& input': {
      padding: 0,
      height: T.rowHeight - 2,
      '&::placeholder': { color: T.placeholder, opacity: 1 },
    },
  },
  trailing: {
    flex: 'none',
    width: 34,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: T.muted,
  },
  clear: {
    width: 28,
    height: 28,
    padding: 0,
    color: T.muted,
    '&:hover': { color: T.text, backgroundColor: 'transparent' },
  },
}));

function AddressSearchInput({
  value, onChange, onSubmit, onClear, onKeyDown,
  loading = false, autoFocus = false, placeholder = '주소 또는 건물명', className, inputRef,
}) {
  const cs = useStyles();

  const handleKeyDown = (e) => {
    if (onKeyDown && onKeyDown(e) === true) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      if (onSubmit) onSubmit();
    }
  };

  return (
    <div className={clsx(cs.root, className)}>
      <span className={cs.icon}><AddressIcon name="search" /></span>
      <InputBase
        className={cs.input}
        inputRef={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        autoFocus={autoFocus}
        inputProps={{ 'aria-label': '주소 검색', autoComplete: 'off', spellCheck: false }}
      />
      <span className={cs.trailing}>
        {loading
          ? <CircularProgress size={18} thickness={4} color="primary" />
          : value
            ? (
              <IconButton className={cs.clear} aria-label="지우기" onClick={onClear}>
                <AddressIcon name="close" size={18} />
              </IconButton>
            )
            : null}
      </span>
    </div>
  );
}

export default AddressSearchInput;
